const Events = {
  onEmailSubmit: 'onEmailSubmit',
};

export default Events;
